import { apiClient } from './api/apiClient';

export interface Role {
  _id: string;
  name: string;
  label: string;
  description?: string;
  isSystem: boolean;
  createdAt?: string;
  updatedAt?: string;
}

class RoleService {
  async getAllRoles(): Promise<Role[]> {
    const res = await apiClient.get<Role[]>('/api/roles', false);
    return (res as any).data ?? [];
  }

  async createRole(data: { name: string; label: string; description?: string }): Promise<Role> {
    const res = await apiClient.post<Role>('/api/roles', data, true);
    return (res as any).data!;
  }

  async updateRole(id: string, data: { label?: string; description?: string }): Promise<Role> {
    const res = await apiClient.put<Role>(`/api/roles/${id}`, data, true);
    return (res as any).data!;
  }

  async deleteRole(id: string): Promise<void> {
    await apiClient.delete(`/api/roles/${id}`, true);
  }
}

export default new RoleService();
